<template>
    <div class="column">
        <div class="flex_r_between">
            <div class="title f32 line44 fw600">
                <svgIcon v-if="title.indexOf('视频')>-1" name='play' class="ftheme" /> 
                <svgIcon v-if="title.indexOf('音频')>-1"  name='radio' class="ftheme" /> 
                <svgIcon v-if="title.indexOf('文稿')>-1"  name='text' class="ftheme" /> 
                {{title}}
            </div>
            <router-link :to="'/category?type='+type" class="more f16 line22 ftheme">查看更多<svgIcon name='more' /></router-link>
        </div>
        <section class="pt36">
            <myVideo  :videoArr='videoArr' />    
        </section> 
 
    </div>
</template>
<script>
export default {
    name: 'column',
    props:{
        title:{
            type:String,
            default:'不限'
        },
        videoArr:{
            require: true,
            default: ()=>[]
        }
    },
    computed:{
        type(){
            let typeArr = ['不限', '视频专栏', '音频专栏', '文稿专栏'];
            let type =  typeArr.indexOf(this.title)
            return type
        }
    }
}
</script>
<style lang="less" scoped>
.column{
    padding-top: 60px;
}

</style>